if (!customElements.get('mobile-menu-tabs')) {
  customElements.define('mobile-menu-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.onClick = event => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.select(tab);
      };
      this.onKeyDown = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        switch (event.key) {
          case 'ArrowRight': next = (index + 1) % this.tabs.length; break;
          case 'ArrowLeft': next = (index - 1 + this.tabs.length) % this.tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = this.tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      if (this.tabs.length) this.select(this.tabs[0], false);
    }

    select(selected, scroll = true) {
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.id !== selected.getAttribute('aria-controls');
      });
      if (scroll) selected.scrollIntoView({block: 'nearest', inline: 'nearest'});
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }
  });
}
